import React, { useRef, useState, useEffect } from "react";
import axiosInstance from '../../server/axios.js';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import Downexcel from "../data/downexcel.js";

import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip,ResponsiveContainer,Legend,BarChart,Bar,ComposedChart   } from 'recharts';

import * as XLSX from "xlsx";
import {FixedSizeList} from "react-window";


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
    >
    {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}
  function a11yProps(index) {
    return {id: `simple-tab-${index}`,'aria-controls': `simple-tabpanel-${index}`};
  }
const Analysis = () => {
  //tab value variable
  const [thisDate, setThisDate] = useState(new Date());
  const [thisYear, setThisYear] = useState(thisDate.getFullYear());
  const [value, setValue] = useState(0);
  const [detector, setDetector] = useState(0);
  const [codelist, setCodeList] = useState([]);
  const [list, setList] = useState([]);
  const [menuList, setMenuList] = useState([]);

  const [list2, setList2] = useState([]);
  const [menuList2, setMenuList2] = useState([]);
  const [list3, setList3] = useState([]);
  const [menuList3, setMenuList3] = useState([]);
  const [list4, setList4] = useState([]);
  const [menuTest, setMenuTest] = useState([]);

  const [ChartYearData, setChartYearData] = useState([]);
  const [ChartYearData2, setChartYearData2] = useState([]);
  const dataColor = ['pink','powderblue','green','purple','magenta','orange','brown','coral']
  //height
  const [height, setHeight] = useState(window.innerHeight-220);
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(()=>{getCompanySales();},[detector])
  const getCompanySales = async () => {
    const result = await axiosInstance.get('company/salesbycompany');
    const menulist = Object.keys(result.data[0][0]);
    setMenuList([...menulist]);
    setList([...result.data[0]]);

    const menulist2 = Object.keys(result.data[1][0]);
    setMenuList2([...menulist2]);
    setList2([...result.data[1]]);

    const menulist3 = Object.keys(result.data[4][0]);
    setMenuList3([...menulist3]);
    setList3([...result.data[4]]);
    setList4([...result.data[5]]);

    setCodeList([...result.data[3]]);


    const menuarr = [];
    for(let i = 0; i < menulist.length; i++){
      if(i ==! 2){menuarr.push(menulist[i]);}
    }
    setMenuTest([...menuarr]);

    const chartdata = result.data[2];
    const userdata = [];

    const goal = [4300000000/12];
    let checkgoal = 0;
    let twomonthData = 0;
    let lastmonthData = 0;
    let thismonthData = 0;

    const thisMonth = thisDate.getMonth();

    for(let i = 0; i < 12; i++){
      const twomonth= i+1 < 10 ? 'a0'+(i+1) : 'a'+(i+1);
      const lastmonth= i+1 < 10 ? 'b0'+(i+1) : 'b'+(i+1);
      const monthName = lastmonth.replace('b','') + '월';
      twomonthData += Number(chartdata?.[0]?.[twomonth] || 0);
      lastmonthData += Number(chartdata?.[0]?.[lastmonth] || 0);
      checkgoal = i > 8 ? checkgoal += Math.round(goal[0]) : checkgoal += 0;
      const momthObj = {name:monthName,[thisYear-2]:twomonthData,[thisYear-1]:lastmonthData,goal:checkgoal};
      userdata.push(momthObj);
    }
    setChartYearData([...userdata]);
  }

  const stockInfo = async (materialCode) => {
    //console.log(materialCode);
    //const materialinfo = await axiosInstance.get('material/info');
  }
  const DataFormater = (number) => {
    if(number === 0){return '';}
    if(number === null){return '';}
    if(number >= 100000000){
      const checknumber = Math.round(number/100000000*100)/100;
      return checknumber+'억';
    }else if(number > 10000){
      const checknumber = Math.round(number/10000);
      return checknumber+'만';
    }
    if(number >= -100000000){
      const checknumber = Math.round(number/100000000*100)/100;
      return checknumber+'억';
    }else if(number > -10000){
      const checknumber = Math.round(number/10000);
      return checknumber+'만';
    }else{
      return number+'';
    }
  }
/*
  const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill={'black'} textAnchor="middle" fontSize={13} dy={-6}>{`${DataFormater(value)}`}</text>;
  };
*/
  const renderCustomBarLabel = (props) => {const { x, y, width, value } = props;
      if (x === undefined ||y === undefined ||width === undefined ||isNaN(x) ||isNaN(width)) {return null;}
    return (
      <text
        x={x + width / 2}
        y={y}
        fill="black"
        textAnchor="middle"
        fontSize={13}
        dy={-6}
      >
        {DataFormater(value)}
      </text>
    );
  };

  const renderYearChart = (
    <ResponsiveContainer width='90%' height={800} >
      <ComposedChart  width={500} height={600} data={ChartYearData} margin={{ top: 10, right: 150, bottom: 5, left: 0 }}>
      <XAxis dataKey={'name'} stroke="#8884d8" />
      <YAxis tickFormatter={DataFormater}/>
      <Tooltip formatter={(value) => new Intl.NumberFormat('en').format(value)} />
      <Legend width={100} wrapperStyle={{ top: 50, right: 20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, lineHeight: '40px',fontSize:13 }} />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <Bar  
        fill={dataColor[0]}
        dataKey={thisYear-2} 
        label={renderCustomBarLabel}
      />
      <Bar  
        fill={dataColor[1]}
        dataKey={thisYear-1} 
        label={renderCustomBarLabel}
      />
      <Line
        fill={dataColor[2]}
        dataKey={'goal'} 
        label={renderCustomBarLabel}
      />
    </ComposedChart >
    </ResponsiveContainer>
  );

  const changeNumber = (_number) => {
    return _number === '0' || _number === 0 ? '' : Number(_number).toLocaleString() ;
  }

  //import excel
  const MAX_FILES = 10;
  const [excelFiles, setExcelFiles] = useState([]);
  const dropRef = useRef(null);

  useEffect(() => {
    const dropBox = dropRef.current;
    if (!dropBox) return;
  
    const prevent = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  
    dropBox.addEventListener("dragenter", prevent);
    dropBox.addEventListener("dragover", prevent);
    dropBox.addEventListener("dragleave", prevent);
    dropBox.addEventListener("drop", handleDrop);
  
    return () => {
      dropBox.removeEventListener("dragenter", prevent);
      dropBox.removeEventListener("dragover", prevent);
      dropBox.removeEventListener("dragleave", prevent);
      dropBox.removeEventListener("drop", handleDrop);
    };
  }, []); 

  const readExcelFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const wb = XLSX.read(binaryStr, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const sheetData = XLSX.utils.sheet_to_json(ws);
        resolve({
          fileName: file.name,
          data: sheetData,
        });
      };
      reader.readAsBinaryString(file);
    });
  };

  const handleFiles = async (files) => {
    const fileArray = Array.from(files)
      .filter(file =>
        file.name.endsWith(".xls") ||
        file.name.endsWith(".xlsx") ||
        file.name.endsWith(".csv")
      )
      .slice(0, MAX_FILES - excelFiles.length);

    const parsedFiles = await Promise.all(
      fileArray.map(file => readExcelFile(file))
    );

    setExcelFiles(prev => [...prev, ...parsedFiles].slice(0, MAX_FILES));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation(); 
    handleFiles(e.dataTransfer.files);
  };
  const handleChange = (e) => {
    handleFiles(e.target.files);
    e.target.value = "";
  };
  const deleteFile = (index) => {
    setExcelFiles(prev => prev.filter((_, i) => i !== index));
  };

  const checkExcelFiles = async() => {
    const excelData = excelFiles[0].data
    const excelFileName = excelFiles[0].fileName
    const titlelist = Object.keys(excelFiles[0].data[0]);

    const checkCode = titlelist.indexOf('거래처코드');
    if(checkCode === -1){return alert(`${excelFileName} [거래처코드] 가 없는 파일 입니다`);}

    const checkAlready = titlelist.indexOf('담당영업사원;');
    if(checkAlready !== -1){return alert(`${excelFileName} 이미 작업 완료된 파일 입니다`);}

    titlelist.splice(checkCode+1, 0, '담당영업사원;');
    const exportList = [];
    const codeMap = Object.fromEntries(codelist.map(item => [item.companycode, item.manager]));
    for(let i = 0; i < excelData.length; i++){
      const rowArray = [];
      for(let j = 0; j < titlelist.length; j++){
        if(titlelist[j] !== '담당영업사원;'){
          rowArray.push(excelData[i][titlelist[j]]);
        }else{
          const companycode = excelData[i]['거래처코드'];
          rowArray.push(codeMap[companycode]);
        }
      }
      exportList.push(rowArray);
    }
    setExcelFiles([]);
    alert('엑셀파일 변환 완료');
    return exceldown(titlelist,exportList,excelFileName);
  }
  const exceldown = (title,contents,filename) => {
      try{
          const wb = XLSX.utils.book_new();
          const rows = [title, ...contents];
          const ws = XLSX.utils.aoa_to_sheet(rows);
          XLSX.utils.book_append_sheet(wb, ws);
          // 파일 다운로드
          XLSX.writeFile(wb, `${filename}`);
          console.log('Excel 파일 생성 및 다운로드 완료');
      }catch(error){
          console.error('Error occurred while downloading Excel', error);
      }
  }


  return (
    <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
            <Tab label="업체별 매출" {...a11yProps(0)} />
            <Tab label="품목별 매출" {...a11yProps(1)} />
            <Tab label="CHART" {...a11yProps(2)} />
            <Tab label="담당입력" {...a11yProps(3)} />
            <Tab label="월별 품목별 매출 금액" {...a11yProps(4)} />
            <Tab label="월별 품목별 매출 수량" {...a11yProps(5)} />
        </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
        <div style={{display:'inline-block'}}>{Downexcel(menuList,list,'company_sales_data_2years')}</div>
        <table className="company_main">
          <thead key={'head'}>
          <tr key={'menu'}>
          {menuList.map((menu,i)=>
            i === 1 ? '' :
            <th key={i+menu}>{menu}</th>
          )}
          </tr>
          </thead>
          <tbody>
          {list.map((data,index)=>
          <tr key={data.코드+index} >
            {menuList.map((value,i)=>
            i === 0 ? <td align="left">{data[menuList[i]]}</td> :
            i === 1 ? '' :
            i === 2 ? <td style={{whiteSpace:"nowrap"}}>{data[menuList[i]]}</td>
             : <td align="right">{data[menuList[i]]}</td>
            )}
          </tr>
          )}
          </tbody>
        </table>
        </CustomTabPanel>

<CustomTabPanel value={value} index={1}>
<div style={{display:'inline-block'}}>{Downexcel(menuList2,list2,'company_sales_data_2years')}</div>

<div style={{display:'grid',gridDirection:'column'}}>
  <div style={{display:'grid',gridTemplateColumns:'120px 80px 150px repeat(24 ,80px)'}}>
    {menuList2.map((menu, i) =>
      i === 0 ? 
      <div style={{
        padding:'1px',
        borderBottom:' 1px solid #ddd',
  /*      position: 'sticky',
        left: 0,
        zIndex: 3,*/
        background: '#fff'
      }} key={i}>{menu}</div> 
      :
      i === 1 || i === 4 ? null :
      <div style={{padding:'1px',borderBottom:' 1px solid #ddd'}} key={i}>{menu}</div>
    )}
  </div>
  <FixedSizeList
    height={height}
    itemCount={list2.length}
    itemSize={28}
    width="2290px"
  >
    {({ index, style }) => (
      <div style={{
        ...style,
        display:'grid',
        gridTemplateColumns:'120px 80px 150px repeat(24 ,80px)',
      }}>
        <div style={{
        textAlign:'left',
        fontSize:'0.8rem',
        overflow : 'hidden',
        justifyContent:'start',
        whiteSpace:'nowrap',
        padding:'1px',
        border:' 1px solid #ddd',
        background: '#fff'}}>{list2[index]["거래처명"]}</div>
        <div style={{textAlign:'center',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["담당"]}</div>
        <div style={{textAlign:'left',fontSize:'0.8rem',overflow : 'hidden',justifyContent:'start',whiteSpace:'nowrap',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["품명"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_01"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_02"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_03"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_04"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_05"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_06"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_07"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_08"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_09"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_10"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_11"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2025_12"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_01"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_02"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_03"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_04"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_05"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_06"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_07"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_08"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_09"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_10"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_11"]}</div>
        <div style={{textAlign:'right',fontSize:'0.8rem',padding:'1px',border:' 1px solid #ddd'}}>{list2[index]["2026_12"]}</div>
      </div>
    )}
  </FixedSizeList>
</div>
</CustomTabPanel>

  <CustomTabPanel value={value} index={2}>
    <div className="chartcontents">{renderYearChart}</div>
  </CustomTabPanel>
  
  <CustomTabPanel value={value} index={3}>
        <div>
      <div><h2>영업사원 담당 추가</h2></div>
        <div
          ref={dropRef}
          onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
          onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleFiles(e.dataTransfer.files);
          }}
          style={{
            margin: "50px",
            border: "3px dashed #999",
            padding: "50px",
            textAlign: "center",
          }}
        >
      엑셀 파일을 드래그 앤 드롭하세요(xls, xlsx) 외 업로드 불가
      {excelFiles.length > 0 ? 
      <div>
        <ul style={{ marginTop: "15px",border:'1px solid red'}}>
        {excelFiles.map((file, idx) => (
          <li key={idx} style={{ marginBottom: "8px" }}>
            {file.fileName} ({file.data.length} rows)
            <button
              onClick={() => deleteFile(idx)}
              style={{
                marginLeft: "10px",
                color: "white",
                background: "red",
                border: "none",
                cursor: "pointer",
              }}
            >삭제
            </button>
          </li>
        ))}
      </ul>
      <Button 
        variant="outlined" 
        color="primary"
        onClick={()=>checkExcelFiles()}
      >
        엑셀 파일 {excelFiles.length} 개 전송
      </Button>
      </div>
        :
      <></>
      }
      </div>
      <input type="file" multiple onChange={handleChange} />
    </div>
        </CustomTabPanel>

  <CustomTabPanel value={value} index={4}>
  <div style={{display:'inline-block'}}>{Downexcel(menuList3,list3,'company_sales_data_2years')}</div>
  <table className="company_main">
    <thead key={'head3'}>
    <tr key={'menu3'}>
    {menuList3.map((menu,i)=>
      i === 1 ? '' :
      <th key={'menu3'+i+menu}>{menu}</th>
    )}
    </tr>
    </thead>
    <tbody>
    {list3.map((data,index)=>
    <tr key={'menu3'+data.코드+index} >
      {menuList3.map((value,i)=>
      i === 0 ? <td align="left">{data[menuList3[i]]}</td> :
      i === 1 ? '' :
      <td align="right">{changeNumber(data[menuList3[i]])}</td>
      )}
    </tr>
    )}
    </tbody>
  </table>
  </CustomTabPanel>
  <CustomTabPanel value={value} index={5}>
  <div style={{display:'inline-block'}}>{Downexcel(menuList3,list4,'company_sales_data_2years')}</div>
  <table className="company_main">
    <thead key={'head3'}>
    <tr key={'menu3'}>
    {menuList3.map((menu,i)=>
      i === 1 ? '' :
      <th key={'menu3'+i+menu}>{menu}</th>
    )}
    </tr>
    </thead>
    <tbody>
    {list4.map((data,index)=>
    <tr key={'menu3'+data.코드+index} >
      {menuList3.map((value,i)=>
      i === 0 ? <td align="left">{data[menuList3[i]]}</td> :
      i === 1 ? '' :
      <td align="right">{changeNumber(data[menuList3[i]])}</td>
      )}
    </tr>
    )}
    </tbody>
  </table>
  </CustomTabPanel>
    </Box>
  )
}
export default Analysis;